import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Starts each catalog export screen at the top. The app scrolls inside `<main id="main-content">`
 * (authenticated-layout), not the window, so a route change would otherwise keep the previous
 * page's scroll offset. Keyed on the pathname only — tab/filter search changes keep their place.
 */
export function useMainScrollReset(): void {
  const pathname = useLocation({ select: (location) => location.pathname });
  useEffect(() => {
    document.getElementById('main-content')?.scrollTo({ top: 0 });
  }, [pathname]);
}
